var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello-ezuikit-js"},[_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"mask",style:({ 'display': _vm.play ? 'none' : 'block' }),on:{"click":_vm.togglePlay}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }